import { ca } from '@cian/analytics';

type TTrackSubAgentsListOpen = {
  pageNumber: number;
  products: { id: number; offerType: string; position: number }[];
  source: 'tab' | 'cross';
};

export function trackSubAgentsListOpen({ pageNumber, products, source }: TTrackSubAgentsListOpen) {
  try {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Chat',
      action: 'Open_sopr',
      label: 'AgentList',
      page: {
        listingType: 'list',
        pageNumber,
        extra: {
          source,
        },
      },
      products,
    });
  } catch (error) {
    console.debug('trackSubAgentsListOpen', error);
  }
}
